import { isNodeV2 } from '@vedalib/editor'

import { updateNodeState } from 'services/Store/Project/actions'
import {
  getBlock,
  getDeviceMode,
  getIsEditingGrid,
  getSelectedNodeIds,
  mergeNodeStyle,
} from 'services/Store/Project/selectors'
import store from 'services/Store/store'

import { isGrid } from '../guards'

export const onEditGrid = async () => {
  const state = store.getState().project
  const dispatch = store.dispatch
  const selectedNodes = getSelectedNodeIds(state)
  const block = getBlock(state)
  const node = selectedNodes.length === 1 ? block?.schema.nodes[selectedNodes[0]] : null
  const styles = isNodeV2(node) ? mergeNodeStyle(node.style, getDeviceMode(state)) : null
  if (block && node && isGrid(styles)) {
    const isEditingGrid = getIsEditingGrid(state, node.id)
    dispatch(updateNodeState({ id: node.id, state: { isEditingGrid: !isEditingGrid } }))
  }
}
